export interface AccessTokenData {
  deviceId: string;
  extension_ClientName: string;
  extension_ClientId: string;
  oid: string;
}
